import {
	getFormattedPhone,
	type VendorPhone,
} from "./vendor.get-formatted-phone";

export function VendorDetailsPhone({ contact }: VendorPhone) {
	const formatted = getFormattedPhone({ contact });

	if (!formatted.phoneFormatted && !formatted.mobileFormatted) {
		return null;
	}

	return (
		<div className="flex flex-col">
			{formatted.phoneFormatted && <span>{formatted.phoneFormatted}</span>}
			{formatted.mobileFormatted && <span>{formatted.mobileFormatted}</span>}
		</div>
	);
}
